import { API_PDC_URL_V2 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const customersConstants = {
  GET_FULFILMENT_CUSTOMERS_START: "GET_FULFILMENT_CUSTOMERS_START",
  GET_FULFILMENT_CUSTOMERS_SUCCESS: "GET_FULFILMENT_CUSTOMERS_SUCCESS",
  GET_FULFILMENT_CUSTOMERS_ERROR: "GET_FULFILMENT_CUSTOMERS_ERROR",

  GET_FULFILMENT_BACKOFFICE_CUSTOMERS_START: "GET_FULFILMENT_BACKOFFICE_CUSTOMERS_START",
  GET_FULFILMENT_BACKOFFICE_CUSTOMERS_SUCCESS: "GET_FULFILMENT_BACKOFFICE_CUSTOMERS_SUCCESS",
  GET_FULFILMENT_BACKOFFICE_CUSTOMERS_ERROR: "GET_FULFILMENT_BACKOFFICE_CUSTOMERS_ERROR",

  GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_START: "GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_START",
  GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_SUCCESS: "GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_SUCCESS",
  GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_ERROR: "GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_ERROR"
};

export function getFulfilmentCustomers(
  auth, fulfilmentId, managerId, itemId, showAll
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: customersConstants.GET_FULFILMENT_CUSTOMERS_START
      });
      let request = {
        method: "GET",
        url: `${API_PDC_URL_V2}/fulfilments/${fulfilmentId}/customers?ownerId=${managerId}` + (showAll ? "&showAll=true" : ""),
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: customersConstants.GET_FULFILMENT_CUSTOMERS_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: customersConstants.GET_FULFILMENT_CUSTOMERS_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function getBackofficeFulfilmentCustomers(
  auth, fulfilmentId, managerId, itemId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_START
      });
      let request = {
        method: "GET",
        // url: `${API_PDC_URL_V2}/fulfilments/backoffice/customers`,
        url: `${API_PDC_URL_V2}/fulfilments/${fulfilmentId}/customers?ownerId=${managerId}&showAll=true`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function getCustomersWithoutFulfilmentId(auth, ownerId) {
  let request = {
    method: "get",
    url: API_PDC_URL_V2 + "/customers?ownerId=" + ownerId,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
  };

  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
